// extracted by mini-css-extract-plugin
export var label = "newsletter-betting-module--label--0dbd3";
export var odds = "newsletter-betting-module--odds--cd4ae";
export var option = "newsletter-betting-module--option--9668c";
export var options = "newsletter-betting-module--options--02e99";
export var spin = "newsletter-betting-module--spin--b433d";
export var team = "newsletter-betting-module--team--4bcb8";
export var teamLogo = "newsletter-betting-module--teamLogo--dcce8";
export var teamName = "newsletter-betting-module--teamName--95981";
export var teams = "newsletter-betting-module--teams--2ddd8";
export var wrapper = "newsletter-betting-module--wrapper--651bc";